var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 5,
    viewBox: "0 0 18 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.615234 2.99805C0.426432 3.06966 0.276693 3.18197 0.166016 3.33496C0.0553387 3.48795 0 3.65234 0 3.82812C0 4.12109 0.094401 4.36361 0.283203 4.55566C0.472005 4.74772 0.70638 4.84375 0.986328 4.84375C1.13607 4.84375 1.2972 4.81283 1.46973 4.75098C1.64226 4.68913 1.79037 4.63216 1.91406 4.58008L9.39453 1.65039H8.01758L15.498 4.58008C15.6217 4.63216 15.7715 4.68913 15.9473 4.75098C16.123 4.81283 16.2825 4.84375 16.4258 4.84375C16.7057 4.84375 16.9401 4.74772 17.1289 4.55566C17.3177 4.36361 17.4121 4.12109 17.4121 3.82812C17.4121 3.65234 17.3568 3.48795 17.2461 3.33496C17.1354 3.18197 16.9857 3.06966 16.7969 2.99805L10.1367 0.390625C9.90885 0.30599 9.66797 0.219727 9.41406 0.131836C9.16015 0.0439453 8.92578 0 8.71094 0C8.48959 0 8.25196 0.0439453 7.99805 0.131836C7.74414 0.219727 7.50651 0.30599 7.28516 0.390625L0.615234 2.99805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/Arrow-Up.35d4168e4a26ccf510cfbcc2f458887d.svg";
export { ForwardRef as ReactComponent };